<template>
  <div id="app">
    <template v-if="type === 'sm'">
      <div class="sm">
        <img src="../src/assets/提煤备份.jpg" width="100%" height="100%" alt="">
      </div>
    </template>
    <template v-if="type === 'tm'">
      <div class="sm">
        <img src="../src/assets/提煤.jpg" width="100%" height="100%" alt="">
      </div>
    </template>
    <template v-if="type === 'fy'">
      <div class="sm">
        <img src="../src/assets/发运备份.jpg" width="100%" height="100%" alt="">
      </div>
    </template>
    <template v-if="type === 'sp'">
      <div class="sm">
        <img src="../src/assets/一屏备份.jpg" width="100%" height="100%" alt="">
      </div>
    </template>
    <template v-if="type === 'sh' || type === 'mcsh'">
      <platform-audit :type="type" />
    </template>
    <template v-if="type === 'mx'">
      <base-model />
    </template>
    <template v-if="type === 'pt'">
      <platform-tenant />
    </template>
    <template v-if="type === 'business'">
      <business />
    </template>
    <template v-if="type === 'operate'">
      <operate />
    </template>
    <template v-if="type === 'order_share'">
      <OrderShare />
    </template>
    <template v-if="type === 'paying'">
      <Paying />
    </template>
    <template v-if="type === ''">
      <router-view />
    </template>
    <template v-if="type === 'pdf'">
      <pdf-look />
    </template>
    <template v-if="type === 'white'">
      <white />
    </template>
    <template v-if="type === 'app'">
      <app-config />
    </template>
    <template v-if="type === 'point'">
      <point />
    </template>
    <template v-if="type === 'two'">
      <two-tenant />
    </template>
    <template v-if="type === 'record'">
      <operate-record />
    </template>
  </div>
</template>

<script>
import PlatformAudit from "./components/PlatformAudit.vue";
import baseModel from "./components/baseModel/baseModel.vue";
import platformTenant from "./components/platformTenant";
import business from "./components/business";
import operate from "./components/operate";
import pdfLook from "./components/pdfLook.vue";
import OrderShare from "./components/operate/order_share.vue"
import Paying from "@/components/paying/index.vue";
import White from "@/components/white/index.vue";
import AppConfig from "@/components/app/index.vue"
import Point from "@/components/point/index.vue"
import TwoTenant from "@/components/twoTenant/index.vue"
import OperateRecord from "@/components/operateRecord/index.vue"

export default {
  name: 'App',
  components: { PlatformAudit, baseModel, platformTenant, business, operate, pdfLook, OrderShare, Paying, White, AppConfig, Point, TwoTenant, OperateRecord },
  data() {
    return {
      type: ''
    }
  },
  mounted() {
    const search = window.location.search
    let params = {}
    if (search !== '') {
      //如果search不是空字符串
      search
        .slice(1)
        .split('&')
        .forEach(val => {
          const arr = val.split('=') //将当前元素值按=切割，保存在arr中
          params[arr[0]] = arr[1] //向params中添加一个元素,属性名为arr[0],值为arr[1]
        })
    }
    if (params.type) this.type = params.type
  }
}

</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  min-width: 1000px;
  min-height: 500px;
}

.sm {
  width: 100%;
  height: 100%;
}
</style>
